import { IBudgetActionFilterRequest } from '../../../../model/sge/budget-action/request/budget-action-filter-request';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';

export type BudgetActionSearchState = {
    parameters: IBudgetActionFilterRequest;
    budgetPrograms: IBudgetProgramResponse[];
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    setBudgetPrograms = 'setBudgetPrograms',
    triggerSearch = 'triggerSearch',
}

export const BudgetActionSearchReducer = (state: BudgetActionSearchState, action: any): BudgetActionSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.setBudgetPrograms:
            return { ...state, budgetPrograms: payload };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
